module.exports = "pegasus/assets/blocks/column-6-basic.png";